<template>
    <el-scrollbar>
        <div class="view-modal window-scorll">
            <div class="view">
                <!-- <div class="aaa-lists">
                    <div v-for="list in 200" class="aaa-list"></div>
                </div> -->
                <div class="vue-slot">
                    <h3>这里是父组件</h3>
                    <br>
                    <vue-slot-child>
                        <vue-slot-child-next slot="childNext" class="fs-12"></vue-slot-child-next>
                        <div class="tmpl fs-12" slot="up">
                            <span>up</span>
                        </div>
                        <div class="tmpl fs-12" slot="down">
                            <span>down</span>
                        </div>
                        <div class="tmpl fs-12">
                            <span>菜单</span>
                        </div>
                    </vue-slot-child>
                    

                    <a :href="imgSrc" :download="input.value + '.png'">
                        <img :src="imgSrc" alt="">
                    </a>
                    <div class="qriously" v-show="input.value">
                        <qriously :value="input.value" :size="input.size" :backgroundAlpha="input.backgroundAlpha"/>
                    </div>
                    <el-input type="text" v-model="input.value" @keydown.native.enter="createQrious"></el-input>
                    <div id="VM-test"></div>
                </div>
            </div>
            
        </div>
    </el-scrollbar>
</template>
<script>
    import $ from 'jquery';

    import vueSlotChild from './vue-slot-child.vue'
    import vueSlotChildNext from './vue-slot-child-next.vue'

    import Vue from 'vue';
    import Qrious from 'qrious'
    import VueQriously from 'vue-qriously';
    Vue.use(VueQriously);
    export default{
        name:'VueSlot',
        data(){
            return {
                imgSrc:'',
                input:{
                    // 可以自定义，必填项。
                    value: '18458161622',
                    // 二维码大小 默认 100
                    size: 240,
                    // 背景透明度，默认透明 0
                    backgroundAlpha: 1,
                },
                lists:[],
                click_time:null
            }
        },
        methods:{
            downloadQriously(){
            },
            createQrious(){
                var canvas = document.getElementsByTagName("canvas")[0];
                canvas.setAttribute('id', 'qriously')
                var qriously = document.getElementById('qriously');
                console.log(qriously)
                this.imgSrc = qriously.toDataURL("image/png");
                console.log(this.imgSrc)
            },
            itemClick(e, a=null, b=null, c=null, d=null){
                console.log(e.type)
                console.log(a)
                console.log(b)
                console.log(c)
                console.log(d)
                console.log('onclick')
            },
            itemDblclick(e){
                console.log(e.type)
                console.log('ondblclick')
            },
            itemMouseover(e){
                console.log('onmouseover')
            },
            itemMousemove(e){
                console.log('onmousemove')
            },
            itemMouseout(e){
                console.log('onmouseout')
            },
            VDtest(){
                const tree = this.$VD('div', { id: 'virtual-container' }, [
                    this.$VD('p', {}, ['Virtual DOM']),
                    this.$VD('div', {}, ['before update']),
                    this.$VD('ul', {}, [
                        this.$VD('li', { class: 'item' }, ['Item 1']),
                        this.$VD('li', { class: 'item' }, ['Item 2']),
                        this.$VD('li', { class: 'item' }, ['Item 3']),
                    ]),
                ]);

                const root = tree.render();
                document.getElementById('VM-test').innerHTML = '';
                document.getElementById('VM-test').appendChild(root);
            },
            VDNewtest(){
                const tree = this.$VD('div', { id: 'virtual-container' }, [
                    this.$VD('h3', {}, ['Virtual DOM']),
                    this.$VD('div', {}, ['after update']),
                    this.$VD('ul', { class:'items' }, [
                        this.$VD('li', {
                            class: 'item',
                            "data-a": 'a属性',
                            click:{
                                fn:this.itemClick,
                                arg:['item', 1,2]
                            },
                            dblclick:this.itemDblclick,
                        }, ['Item 1']),
                        this.$VD('li', {
                            class: 'item',
                            click:this.itemClick,
                            dblclick:this.itemDblclick,
                            // onmouseover:this.itemMouseover,
                            // onmousemove:this.itemMousemove,
                            // onmouseout:this.itemMouseout
                        }, ['Item 2']),
                        this.$VD('li', {
                            class: 'item',
                            click:this.itemClick,
                            dblclick:this.itemDblclick,
                            // onmouseover:this.itemMouseover,
                            // onmousemove:this.itemMousemove,
                            // onmouseout:this.itemMouseout
                        }, ['Item 3']),
                    ]),
                ]);

                const root = tree.render();
                document.getElementById('VM-test').innerHTML = '';
                document.getElementById('VM-test').appendChild(root);
            },
            moveFn(i){
                let t = +$(".aaa-list").eq(i).attr("data-t");
                let l = +$(".aaa-list").eq(i).attr("data-l");
                let w = +$(".aaa-list").eq(i).attr("data-w");
                let time = +$(".aaa-list").eq(i).attr("data-time");
                $(".aaa-list").eq(i).animate({
                    top:`${t}px`,
                    left:`${l}px`,
                    // width:this.lists[i].width,
                    // height:this.lists[i].width
                }, time);
                setTimeout(() => {
                    $(".aaa-list").eq(i).animate({
                        top:`0px`,
                        left:`0px`,
                        // width:0,
                        // height:0
                    }, time);
                }, time)
            },
            listMove(i){
                let self = this;
                this.$nextTick(() => {
                    $(".aaa-list").each(function(i){
                        let time = +$(".aaa-list").eq(i).attr("data-time");
                        var list_i = setInterval(() => {
                            self.moveFn(i)
                        }, time * 2)
                    })
                })
            }
        },
        created(){
            this.$parent.routerLoading();
        },
        components:{
            vueSlotChild,
            vueSlotChildNext
        },
        mounted(){
            this.VDtest();
            let self = this;
            setTimeout(() => {
                self.VDNewtest()
            }, 2000)


            this.$nextTick(() => {
                let p_w = $(".aaa-lists").width();
                let h = $(".aaa-lists").height();
                for(let i = 0; i < 200; i++){
                    let r = Math.floor(Math.random() * 255);
                    let g = Math.floor(Math.random() * 255);
                    let b = Math.floor(Math.random() * 255);


                    let t = Math.floor(Math.random() * h * 2 - h)
                    let l = Math.round(Math.random()) === 1 ? -(p_w) : p_w;
                    let time = Math.floor(Math.random() * 10000) + 3000;
                    let w = Math.floor(Math.random() * p_w / 5) - 10;
                    $(".aaa-list").eq(i).attr({"data-t": t, 'data-l': l, 'data-w': w, 'data-time': time}).css('border-color', "rgb(" + r + ", " + g + "," + b + ")");
                }
                // this.listMove();
            })
        }
    }
</script>
<style scoped>
    .vue-slot{
        color: red;
    }
    .view{
        position: relative;
    }
    .view .aaa-lists{
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        overflow: hidden;
    }
    .view .aaa-lists .aaa-list{
        width: 0;
        height: 0;
        border-width: 3px;
        border-style: solid;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        border-radius: 50%;
        transform: translate(0,0);
    }
    .vue-slot{
        position: relative;
    }
</style>
<style>
    .item{
        font-size: 20px;
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/components/main-content/slot/vue-slot.vue